// =============================================================================
// app/src/lib/fotosDasCalotas.ts — a foto de cada calota, sem fundo, para
// "vestir" o disco do gancho no mapa da loja (pedido do dono, 01/10/2026).
//
// Os arquivos são app/src/assets/calotas/<product_id>.webp, feitos por
// scripts/calotas-sem-fundo.py a partir da foto principal da peça. Entram no
// build como asset com hash (o Vite só emite a URL; o arquivo baixa quando o
// disco aparece no mapa), e a lista de quem tem foto é a própria pasta.
// =============================================================================

const ARQUIVOS = import.meta.glob<string>('../assets/calotas/*.webp', {
  eager: true, query: '?url', import: 'default',
});

const POR_PECA = new Map(
  Object.entries(ARQUIVOS).map(([caminho, url]) => [caminho.replace(/^.*\/|\.webp$/g, ''), url]),
);

/** A URL da calota sem fundo desta peça, ou undefined se ela não tem. */
export const fotoDaCalota = (productId: string): string | undefined => POR_PECA.get(productId);

/**
 * O disco de cada gancho de calota → a foto que o veste: a da primeira peça
 * cadastrada nele que tem foto. `ondeMora` diz o gancho de cada peça.
 *
 * `tipos` diz que objetos se vestem: por padrão só o disco da calota. O lugar
 * de peça ('vaga', 01/10/2026) passa pelo mesmo caminho, com a foto principal
 * da peça do cadastro (lib/useFotosDasVagas.ts).
 */
export function fotosDosGanchos<P extends { product_id: string; local: string | null }>(
  pecas: readonly P[],
  ganchoDe: (p: P) => { origem: string; tipo: string } | null,
  foto: (productId: string) => string | undefined = fotoDaCalota,
  tipos: readonly string[] = ['calotas'],
): Map<string, string> {
  const fotos = new Map<string, string>();
  for (const p of pecas) {
    const g = ganchoDe(p);
    if (!g || !tipos.includes(g.tipo) || fotos.has(g.origem)) continue;
    const url = foto(p.product_id);
    if (url) fotos.set(g.origem, url);
  }
  return fotos;
}
